import constants from "./constants";
import { publicRequest, privateRequest } from "./axsiosInstances";

class TokenNeeded {
  static request(config) {
    return privateRequest({
      ...config,
    })
      .then(function (response) {
        return Promise.resolve(response);
      })
      .catch((error) => {
        if (!error.response || error.response?.status === 401) {
          return TokenNeeded.refresh(config);
        } else if (error.response?.status === 423) {
          TokenNeeded.navigate("/auth/lock");
        }
        return Promise.reject(error);
      });
  }

  static refresh(config) {
    const refreshToken = localStorage.getItem("refreshToken");
    return publicRequest({
      method: "post",
      url: constants.authentication.publicV1 + "token",
      data: {
        refreshToken: refreshToken || "asdf",
      },
    })
      .then(function (response) {
        localStorage.setItem("accessToken", response.data["access_token"]);
        localStorage.setItem("refreshToken", response.data["refresh_token"]);

        return TokenNeeded.request(config);
      })
      .catch((error) => {
        if (!error.response || error.response?.status === 401) {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          TokenNeeded.navigate("/auth/register");
        }
        return Promise.reject(error);
      });
  }
}

export default TokenNeeded;
